import { useCreate } from '@refinedev/core';

type GenerateMeetingNotePayload = {
  dataUploadFileId: string;
  templateId?: string;
  agendaFileId?: string;
  meetingDate?: Date;
};

export function useGenerateMeetingNote() {
  const { mutateAsync, error, isLoading, reset } = useCreate<GenerateMeetingNotePayload>();

  const generateMeetingNote = async (clientId: string, values: GenerateMeetingNotePayload) => {
    return mutateAsync({
      resource: `clients/${clientId}/meeting-notes`,
      values,
    });
  };

  return {
    generateMeetingNote,
    error,
    isLoading,
    reset,
  };
}
